export default __webpack_public_path__ + "static/media/Leo_Tokens.0b0de92f.png";